import { Controller } from "@hotwired/stimulus"

// Client-side filter for one table: hides rows whose text does not contain the query and shows
// "n of m". Wrap the input and the table in data-controller="table-filter"; rows are the
// <tbody> rows that are not the table's empty-state row. For paginated lists (campaigns index)
// the server-side `q` parameter is the right tool — this is for pages that render every row.
export default class extends Controller {
  static targets = ["input", "count", "empty"]

  connect() { this.filter() }

  filter() {
    const q = this.normalize(this.inputTarget.value)
    let shown = 0
    for (const row of this.rows()) {
      const hit = !q || this.normalize(row.textContent).includes(q)
      row.hidden = !hit
      if (hit) shown++
    }
    const total = this.rows().length
    if (this.hasCountTarget) this.countTarget.textContent = q ? `${shown} of ${total}` : `${total}`
    if (this.hasEmptyTarget) this.emptyTarget.hidden = shown > 0 || total === 0
  }

  clear() {
    this.inputTarget.value = ""
    this.filter()
    this.inputTarget.focus()
  }

  rows() { return Array.from(this.element.querySelectorAll("tbody tr")).filter(r => !r.querySelector("td.empty") && !r.hasAttribute("data-table-filter-empty")) }

  normalize(s) { return s.toLowerCase().replace(/\s+/g, " ").trim() }
}
